import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=499d2464&scoped=true"
import script from "./DeviceStatus.vue?vue&type=script&lang=ts"
export * from "./DeviceStatus.vue?vue&type=script&lang=ts"
import style0 from "./DeviceStatus.vue?vue&type=style&index=0&id=499d2464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d2464",
  null
  
)

export default component.exports